module.exports = __webpack_public_path__ + "img/ch17_06_甜点之问.2c637f27.jpg";